  mobileSize = 1060;
  function buttonfeature() {
    const maxLengthTitle = 150;
    const maxLengthDescription = 180;
  
    $(".featureLineupContainer").each((index, element) => {
      const $element = $(element);
      const $title = $element.find(".featureLineup-title");
      const $description = $element.find(".featureLineup-text");
      const $more = $element.find(".featureLineup-more");
  
      let title = $title.text().trim();
      let description = $description.length > 0 ? $description.text().trim() : '';
  
      // Limit title length
      let trimmedTitle = title.length > maxLengthTitle ? title.substring(0, maxLengthTitle) + '...' : title;
  
      // Limit description length
      let trimmedDescription = description.length > maxLengthDescription ? description.substring(0, maxLengthDescription) + '...' : description;
  
      // Create elements dynamically
      const $textContainer = $('<span>').addClass('featureLineup-text');
      const $textContent = $('<span>').addClass('featureLineup-text-content').text(trimmedDescription);
      const $moreClone = $more;
      const $titleClone = $title.clone();
  
      // Append elements
      $textContainer.append($textContent, $moreClone, $titleClone);
  
      // Update or create description element
      if ($description.length > 0) {
        $description.empty().append($textContainer);
      } else {
        $element.append($textContainer);
      }
  
      // Update title text
      $title.text(trimmedTitle);
    });
  }
  
$(document).ready(function(){
  setTimeout(function() {
    $('.site-infobanner-main').clone().appendTo('.mobile-menu-header');
    //Get the main div with class "mobile-menu-header"
    var mobileMenuHeader = document.querySelector('.mobile-menu-header');

    if (mobileMenuHeader) {
        // Find the event dates div inside mobile-menu-header
        var eventDates = mobileMenuHeader.querySelector('#eventDates');

        if (eventDates) {
            // Get the text content of the div
            var text = eventDates.textContent;

            // Remove the year (assumed to be a four-digit number) and the comma
            var newText = text.replace(/\b\d{4}\b/g, '').replace(/,/g, '');

            // Update the div with the new text
            eventDates.textContent = newText.trim(); // Using trim() to remove any leading or trailing whitespace
        }
    }
}, 3000); 
setTimeout(function() {
  var eventDates = document.getElementById('eventDates');
  if (eventDates) {
      var text = eventDates.innerHTML;
      var newText = text.replace(/\b\d{4}\b/g, '').replace(/,/g, '');
      eventDates.innerHTML = newText;
  }

    }, 3000); 
  buttonfeature();
     // Search Bar Script
     $('.searchBoxInput input').attr('placeholder', 'Search');
     $('.searchBoxInput input').val('');
     
     //copyright 
     let footerDiv = $('.footerItems2 li');

  // Iterate through each matching div
  footerDiv.each(function() {
    // Get the text content of the div
    let text = $(this).text();
    
    // Split the text by the dot (.)
    let parts = text.split('.');
    
    // If there's text after the dot, wrap it in a span
    if (parts.length > 1) {
      // Join all parts except the first one (before the dot)
      var newText = parts.slice(1).join('.');
      
      // Empty the div and append the first part followed by a span containing the rest
      $(this).html(parts[0] + '.<span>' + newText.trim() + '</span>');
    }
  });
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } 
  if (windowSize > 801) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});